import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './cartSlice';
import parcoVeicoliReducer from './parcoVeicoliSlice';
import preventivoReducer from './preventivoSlice';

export const store = configureStore({
    reducer: {
        cart: cartReducer,
        parcoVeicoli: parcoVeicoliReducer,
        preventivo: preventivoReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
